module.exports = __webpack_public_path__ + "dcd315446b4279d097fa0d59a101e121.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/age-gate-bg-320.webp
// module id = 168
// module chunks = 0